import { createSlice } from '@reduxjs/toolkit'
import { IsFlagNonWpsBulkUploadStateType } from 'redux/type'

export const isFlagNonWpsBulkUploadSlice: any = createSlice({
  name: 'isFlagNonWpsBulkUpload',
  initialState: {
    isFlagNonWpsBulkUpload: false
  },
  reducers: {
    setIsFlagNonWpsBulkUpload: (
      state: IsFlagNonWpsBulkUploadStateType,
      action: { payload: boolean }
    ): void => {
      state.isFlagNonWpsBulkUpload = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { setIsFlagNonWpsBulkUpload } = isFlagNonWpsBulkUploadSlice.actions

export default isFlagNonWpsBulkUploadSlice.reducer
